import styled from 'styled-components';

export const CardWrapper = styled.div`
    width: 100%;
    max-width: 24.8125rem;
    height: 27rem;
    gap: 0.75rem;
    border-radius: 1.5rem;
    background-color: #ffffff;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
    margin: 0.625rem;

    @media (min-width: 576px) and (max-width: 1200px) {
        max-width: 22rem;
    }
`;

export const CardContent = styled.div`
    padding: 0 1rem;
    text-align: left;
    width: 100%;
    align-items: flex-start;
`;

export const CardTitle = styled.h2`
    margin: 1rem 0 0.5rem;
    font-size: 1.5rem;
    font-weight: bold;
    align-items: flex-start;
    padding-left: 1.5625rem;
    padding-right: 1.5625rem;
    color: var(--Neutral-950, #09090b);
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.5rem;

    text-align: left;
`;

export const CardDescription = styled.p`
    color: var(--Neutral-500, #71717a);
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    align-items: flex-start;
    padding: 0 1.5625rem;

    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 8;
    line-clamp: 8;
    overflow: hidden;
`;

export const CardActions = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 1.4rem 1.5rem;
    box-sizing: border-box;
    margin-top: auto;

    gap: 0.75rem;
`;

export const WhatsButtonSingle = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0.75rem 1.25rem;
    border-radius: 0.75rem;

    line-height: 1.5rem;

    background-color: ${({ theme }) => theme.colors['green-300']};
    color: ${({ theme }) => theme.colors['neutral-0']};

    border: none;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;

    &:hover {
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.97);
    }
`;
